// extracted by mini-css-extract-plugin
export var button = "_dd-7";
export var buttonRow = "_dd-6";
export var fadeIn = "_dd-1";
export var gradient = "_dd-0";
export var panel = "_dd-2";
export var panelIn = "_dd-3";
export var subtitle = "_dd-5";
export var title = "_dd-4";